export enum ISOLanguageCodes { // language codes in ISO-639-1
  ENGLISH = 'en',
  RUSSIAN = 'ru',
}
